export default "__VITE_ASSET__DPIqY6n7__"